export enum ObesiQState {
    none = 'none',
    notify = 'notify',
}
